import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sendForm } from '@emailjs/browser';
import Banner from '../../components/Banner/banner';
import SEO from '../../components/SEO/SEO';
import imgBanner from '../../assets/img/slider-pagina-writer.jpg';
import ticketCard from '../../assets/logo/ticket-card.png';
import './contact.scss';

const Contact = () => {
  const [t] = useTranslation('global');
  const [status, setStatus] = useState('idle'); // 'idle' | 'sending' | 'success' | 'error'

  const sendEmail = (e) => {
    e.preventDefault();
    const formElement = e.target;
    setStatus('sending');

    sendForm(
      'service_tw28tvg',
      'template_jfzp9mq',
      formElement,
      'op-bEmNqbabpo_lB0'
    )
      .then(() => {
        setStatus('success');
        formElement.reset();
      })
      .catch((error) => {
        console.error('EmailJS Error:', error);
        setStatus('error');
      });
  };

  return (
    <main className="globalContainer">
      <SEO title={t('ContactTitle')} canonicalPath="/contact" />

      <Banner name={imgBanner} alt="Contact Laura Candela" />

      <section className="globalSection" aria-label="Contact Section">
        <h1 className="sectionTitle">{t('ContactTitle')}</h1>

        <div className="contactLayoutWrapper">
          {/* Business Card Showcase */}
          <div className="businessCardShowcase">
            <div className="cardFrame">
              <img
                src={ticketCard}
                alt="Laura Candela - Actriz · Locutora"
                className="businessCardImg"
                loading="eager"
              />
            </div>
            <div className="cardDirectDetails">
              <p className="cardDetailItem">
                <span className="detailLabel">Email:</span>
                <a href="mailto:info@lauracandela.com" className="detailLink">
                  info@lauracandela.com
                </a>
              </p>
              <p className="cardDetailItem">
                <span className="detailLabel">Agency:</span>
                <a
                  href="https://brossontalent.com/D/product/laura-candela/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="detailLink"
                >
                  Brosson Talent
                </a>
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <form
            method="post"
            id="contact-form"
            className="formBox ticketFormBox"
            onSubmit={sendEmail}
            noValidate={false}
          >
            <div className="formGroup">
              <label htmlFor="from_name">{t('ContactForm.Name')}</label>
              <input
                id="from_name"
                className="contactInput"
                type="text"
                name="from_name"
                placeholder={t('ContactForm.Name')}
                required
                autoComplete="name"
              />
            </div>

            <div className="formGroup">
              <label htmlFor="subject">{t('ContactForm.Subject')}</label>
              <input
                id="subject"
                className="contactInput"
                type="text"
                name="subject"
                placeholder={t('ContactForm.Subject')}
                required
              />
            </div>

            <div className="formGroup">
              <label htmlFor="from_email">{t('ContactForm.Email')}</label>
              <input
                id="from_email"
                className="contactInput"
                type="email"
                name="from_email"
                placeholder="ejemplo@correo.com"
                required
                autoComplete="email"
              />
            </div>

            <div className="formGroup">
              <label htmlFor="message">{t('ContactForm.Message')}</label>
              <textarea
                id="message"
                className="contactInput"
                name="message"
                placeholder={t('ContactForm.Message')}
                required
                rows={4}
              />
            </div>

            {status === 'success' && (
              <div className="statusAlert success" role="alert">
                {t('ContactForm.Success')}
              </div>
            )}

            {status === 'error' && (
              <div className="statusAlert error" role="alert">
                {t('ContactForm.Error')}
              </div>
            )}

            <button
              id="submit"
              type="submit"
              className="submitButton ticketSubmitButton"
              disabled={status === 'sending'}
            >
              {status === 'sending'
                ? t('ContactForm.Sending')
                : t('ContactForm.Send')}
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default Contact;